import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { WsSearchbarComponent } from './ws-searchbar.component';

@NgModule({
  declarations: [WsSearchbarComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatCheckboxModule,
    OverlayModule,
    PortalModule,
    MatProgressSpinnerModule,
    WsTooltipModule,
    TranslateModule,
  ],
  exports: [WsSearchbarComponent],
})
export class WsSearchbarModule {}
